export default __webpack_public_path__ + "static/media/desktop-banner.f5a653b5.png";